import { a as languages } from "../../core-8vQkh0Rd.js";
import { r as insertBefore, t as clone } from "../../language-D-vtM55V.js";
import "./cpp.js";
//#region src/prism/languages/cilkcpp.js
insertBefore(languages.cilk = languages["cilk-cpp"] = languages.cilkcpp = clone(languages.cpp), "function", { "parallel-keyword": {
	pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
	alias: "keyword"
} });
//#endregion

//# sourceMappingURL=cilkcpp.js.map